import { connect } from 'react-redux';

import AddHazardReviewDialog from '../../components/AddHazardReviewDialog';
import {
  openAddHazardReviewDialogDispatch,
  handleAddHazardReviewInputChangeDispatch,
  submitHazardReviewDispatch,
  removeHazardReviewAttachment
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    openDialog: state.hazard.newReview.openAddHazardReviewDialog,
    isSaving: state.hazard.newReview.isSaving,
    review: state.hazard.newReview.item,
    hazard: state.hazard.newHazard.item,
    allAttachments: state.hazard.newReview.item.attachmentFiles,
    branchId: state.branch.branch.item && state.branch.branch.item.id
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    onOpenAddHazardReviewDialog: (open) => {
      dispatch(openAddHazardReviewDialogDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleAddHazardReviewInputChangeDispatch(value, inputFieldName));
    },
    submitReview: (payload, mode, branchId) => {
      dispatch(submitHazardReviewDispatch(payload, mode, branchId));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeHazardReviewAttachment(attachment));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddHazardReviewDialog);
